export const STORE_PROJECT_UPLOAD = 'projectUploadUI';
export type STORE_PROJECT_UPLOAD = typeof STORE_PROJECT_UPLOAD;
